import { API_ENDPOINT } from '../../../sharedModules/utils/env';

/** Rails returns `/rails/active_storage/...`; prepend API origin to avoid SPA-host 404s. */
export function apiAbsoluteUrl(pathOrAbsolute: string): string {
  if (/^https?:\/\//i.test(pathOrAbsolute)) return pathOrAbsolute;
  const base = API_ENDPOINT.replace(/\/$/, '');
  const path = pathOrAbsolute.startsWith('/') ? pathOrAbsolute : `/${pathOrAbsolute}`;
  return `${base}${path}`;
}
